import { render, staticRenderFns } from "./BuildPooledPassengerInductions.vue?vue&type=template&id=60b253c6&scoped=true"
import script from "./BuildPooledPassengerInductions.vue?vue&type=script&lang=js"
export * from "./BuildPooledPassengerInductions.vue?vue&type=script&lang=js"
import style0 from "./BuildPooledPassengerInductions.vue?vue&type=style&index=0&id=60b253c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b253c6",
  null
  
)

export default component.exports